import { get } from 'lodash';
import { useOptionalConfig } from '../../../providers/config/ConfigProvider';
import { ReactNode } from 'react';
import { FeatureFlagPath } from '../../../types/env/FeatureFlags.type';

export const useFeature = (feature: FeatureFlagPath): boolean => {
  const featureFlags = useOptionalConfig()?.featureFlags;
  const isFeatureAllowed = get(featureFlags, feature);

  return isFeatureAllowed === true;
};

type NonEmptyFeatureFlags = readonly [FeatureFlagPath, ...FeatureFlagPath[]];

type FeatureResults<TFeatures extends NonEmptyFeatureFlags> = {
  [Index in keyof TFeatures]: boolean;
};

export const useFeatures = <TFeatures extends NonEmptyFeatureFlags>(
  features: TFeatures
): FeatureResults<TFeatures> => {
  const featureFlags = useOptionalConfig()?.featureFlags;

  return features.map(
    (feature) => get(featureFlags, feature) === true
  ) as FeatureResults<TFeatures>;
};

type FeatureToggleRouteProps = {
  component: ReactNode;
  fallback: ReactNode;
  feature: FeatureFlagPath;
};

export const FeatureToggleRoute = ({
  component,
  fallback,
  feature
}: FeatureToggleRouteProps): JSX.Element => {
  const featureEnabled = useFeature(feature);
  return <>{featureEnabled ? component : fallback}</>;
};
